import React from 'react';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';
import Header1 from '../components/Header1';
import Footer from '../components/Footer';
import '@fortawesome/fontawesome-free/css/all.min.css';

const HomePage = () => {
    const navigate = useNavigate();

    return (
        <>
            <Header1 />
            <div className="homepage">
                <main className="homepage-main">
                    <section className="hero-section">
                        <h1>Welcome to Digicard</h1>
                        <p>Your ultimate solution for modern networking.</p>
                        <button onClick={() => navigate('/signup')} className="cta-button">Get Started</button>
                    </section>

                    {/* Features Sections */}
                    <section className="feature-section digital-business-cards">
                        <img src="/businesscards.png" alt="Digital Business Cards" />
                        <div className="feature-text">
                            <h3>Digital Business Cards</h3>
                            <p>Create and share your professional identity with ease.</p>
                        </div>
                    </section>

                    <section className="feature-section contacts">
                        <img src="/contacts.png" alt="Contacts" />
                        <div className="feature-text">
                            <h3>Contacts</h3>
                            <p>Manage and organize your professional connections.</p>
                        </div>
                    </section>

                    <section className="feature-section email-signatures">
                        <img src="/emailsignatures.png" alt="Email Signatures" />
                        <div className="feature-text">
                            <h3>Email Signatures</h3>
                            <p>Design custom email signatures for your brand.</p>
                        </div>
                    </section>

                    <section className="feature-section virtual-backgrounds">
                        <img src="/backgrounds.png" alt="Virtual Backgrounds" />
                        <div className="feature-text">
                            <h3>Virtual Backgrounds</h3>
                            <p>Enhance your online meetings with personalized backgrounds.</p>
                        </div>
                    </section>

                    <section className="feature-section analytics">
                        <img src="/analytics.png" alt="Analytics" />
                        <div className="feature-text">
                            <h3>Analytics</h3>
                            <p>Track and analyze the performance of your networking efforts.</p>
                        </div>
                    </section>
                </main>
            </div>
            <Footer />
        </>
    );
};

export default HomePage;
